import AccordionSection from "@/library/templates/Simple/components/AccordionSection.vue";
import Autocomplete from "@/library/templates/default/components/Autocomplete.vue";
import Button from "@/library/templates/default/components/Button.vue";
import CheckBox from "@/library/templates/default/components/CheckBox.vue";
import CheckBoxList from "@/library/templates/default/components/CheckBoxList.vue";
import ComboBox from "@/library/templates/default/components/ComboBox.vue";
import Date from "@/library/templates/default/components/Date.vue";
import DecimalBox from "@/library/templates/default/components/DecimalBox.vue";
import ErrorBag from "@/library/templates/default/components/ErrorBag.vue";
import FormBuilder from "@/library/templates/Simple/components/FormBuilder.vue";
import Label from "@/library/templates/default/components/Label.vue";
import RadioButtonList from "@/library/templates/default/components/RadioButtonList.vue";
import RadioButtonListSection from "@/library/templates/default/components/RadioButtonListSection.vue";
import RecursiveComponent from "@/library/templates/Simple/components/RecursiveComponent.vue";
import Table from "@/library/templates/Simple/components/Table.vue";
import TextArea from "@/library/templates/default/components/TextArea.vue";
import TextBox from "@/library/templates/default/components/TextBox.vue";
import Wizard from "@/library/templates/Simple/components/Wizard.vue";

import type { IComponentsLibrary } from "@/types/ComponentLibrary/component-library";
import Overlay from "@/library/templates/default/components/Overlay.vue";

//import roComponentsLibrary from "@/library/templates/RO/componentsLib";

let components: IComponentsLibrary = {
  ...{
    ErrorBag: ErrorBag,
    RadioButtonList: RadioButtonList,
    RadioButtonListSection: RadioButtonListSection,
    RecursiveComponent: RecursiveComponent,
    Label: Label,
    CheckBox: CheckBox,
    ComboBox: ComboBox,
    FormBuilder: FormBuilder,
    TextArea: TextArea,
    TextBox: TextBox,
    Button: Button,
    Autocomplete: Autocomplete,
    Table: Table,
    DecimalBox: DecimalBox,
    AccordionSection: AccordionSection,
    CheckBoxList: CheckBoxList,
    Date: Date,
    Wizard: Wizard,
    Overlay: Overlay
  }
};//,...roComponentsLibrary};
export default components;
